export const APP_ROUTES = {
  INVALID_PATH: '*',
  HOME: '/',
  ABOUT_US: '/about-us',
  LEGAL_POLICIES: '/legal-policies',
  PRIVACY_POLICY: '/privacy-policy',
  CONTACTS: '/contacts',
  TERMS_OF_SERVICE: '/terms-of-service',
  REFUND_RETURN_POLICY: '/refund-return-policy',
  COMPLAINTS_WARRANTY_POLICY: '/complaints-warranty-policy',
  SHIPPING_POLICY: '/shipping-policy',
  /// Products
  BUILDER: '/builder',
  PHONE_CASES: '/phone-cases',
  PHONE_CASE_PRODUCT: '/phone-cases/:productId',
  // Admin
  ADMIN_PANEL: '/admin-panel',
  //
  PRODUCTS: '/products',
  PRODUCT: '/product/:productId',
  COURSE_INFO_PREVIEW_ID: '/courses/:courseId',
  COURSE: '/course/:courseId',
  MY_COURSES: '/my-courses',
  USER_CABINET: '/user-cabinet',
  COURSE_INFO_PREVIEW: '/course-info',
  CATEGORY: '/category/:categoryName',
  SUBCATEGORY: '/category/:categoryName/:subcategoryName',
  // Checkout
  CHECKOUT: '/checkout',

  // Unauth
  VERIFY_EMAIL: '/verify-email',
  REQUEST_RESET_PASSWORD: '/request-reset-password',
  RESET_PASSWORD: '/reset-password',
};
